

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { TemplateTextFormComponent } from './templatetext-form/templatetext-form.component';
import { TemplateTextComponent } from './templatetext.component';
import { TemplateTextRoutes } from './templatetext.routing';

export function declaration() {
    return [TemplateTextComponent, TemplateTextFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class TemplateTextModule {
}

@NgModule({
    imports: [TemplateTextModule, TemplateTextRoutes],
    exports: [TemplateTextModule]
})
export class TemplateTextWithRouteModule {
}
